import React from "react";
import { supabase } from "../supabaseClient";

function AuthScreen() {
  const handleGoogleSignIn = async () => {
    const { error } = await supabase.auth.signInWithOAuth({
      provider: "google",
      options: {
        redirectTo: window.location.origin,
      },
    });
    if (error) {
      console.error("Error signing in with Google:", error);
    }
  };

  return (
    <div className="h-screen w-full flex items-center justify-center">
      <div className="flex flex-col items-center justify-center text-center max-w-sm mx-auto p-6">
        <div className="avatar mb-8">
          <div className="w-32 h-32 rounded-full ring ring-primary ring-offset-base-100 ring-offset-2">
            <img
              src="https://vvzldbpwpccdljyhgssa.supabase.co/storage/v1/object/public/avatar//bunny.jpeg"
              alt="Bunny"
            />
          </div>
        </div>

        <h1 className="text-4xl font-bold mb-4">
          Welcome to
          <br />i see a bunny!
        </h1>

        <p className="py-6 text-lg">
          Join us in making language learning fun and interactive. Help our
          bunny friend learn together!
        </p>

        <button
          onClick={handleGoogleSignIn}
          className="btn btn-primary btn-xl w-full max-w-xs"
        >
          Sign in with Google
        </button>

        <div className="mt-4 text-sm text-gray-500">
          By signing in, you agree to our{" "}
          <a
            href="https://talkan.com/iseeabunny/tos.html"
            target="_blank"
            rel="noopener noreferrer"
            className="link link-primary"
          >
            Terms of Service
          </a>{" "}
          and{" "}
          <a
            href="https://talkan.com/iseeabunny/privacy.html"
            target="_blank"
            rel="noopener noreferrer"
            className="link link-primary"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </div>
  );
}

export default AuthScreen;
